// extracted by mini-css-extract-plugin
module.exports = {"noMargin":"DateView_noMargin__3UNVO","noMarginText":"DateView_noMarginText__1VGTU","iconCol":"DateView_iconCol__3j91d","icon":"DateView_icon__1Uo55"};